const i18nConfig = {
    locales: ['en', 'de', 'nl'],
    defaultLocale: 'nl',

    regions: ["NL","BE","DE","GB","AT","BG","HR","CY","CZ","DK","EE","FI","FR","GR","HU","IE","IT","LV","LT","LU","MT","PL","PT","RO","SK","SI","ES","SE","ZZ"],
    defaultRegion: 'ZZ',

    getFullLocale: (locale, region) => {
        return `${locale}-${region}`;
    }
};

module.exports = {
    i18nConfig,
};
